(function () {
  if (window.__rusmCartAnimInit) return;
  window.__rusmCartAnimInit = true;

  const DURATION_MS = 1100;
  const DEBUG_FORCE_LEFT = false;

  const CART_SELECTOR = [
    '.header a[href$="/cart"]',
    '.header [href*="/cart"]',
    '.header__action--cart',
    'a.header__icon--cart',
    '.cart-icon',
    '.cart-toggle',
    '[aria-controls="CartDrawer"]'
  ].join(',');

  const STICKY_CART_SELECTOR = [
    '.mobile-sticky-bar .cart-icon-wrap',
    '.mobile-sticky-bar .cart-drawer-button',
    '.mobile-sticky-bar__cart'
  ].join(',');

  // ——— helpers ———
  function rectInViewport(r, tol = 0) {
    return r.right >= 0 - tol && r.left <= innerWidth + tol && r.bottom >= 0 - tol && r.top <= innerHeight + tol;
  }
  function isRenderable(el) {
    if (!el) return false;
    const cs = getComputedStyle(el);
    if (cs.visibility === 'hidden' || cs.display === 'none' || +cs.opacity === 0) return false;
    const r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }
  function getCartTarget() {
    const stickyActive =
      document.body.classList.contains('mobile-sticky-bar-enabled') &&
      !document.body.classList.contains('mobile-sticky-bar-down') &&
      !(window.matchMedia && window.matchMedia('(min-width: 768px)').matches);

    if (stickyActive) {
      const stickyCart = Array.from(document.querySelectorAll(STICKY_CART_SELECTOR)).filter(isRenderable)[0];
      if (stickyCart) return stickyCart;
    }

    const candidates = Array.from(document.querySelectorAll(CART_SELECTOR)).filter(isRenderable);
    candidates.sort((a, b) => (getComputedStyle(b).position === 'fixed') - (getComputedStyle(a).position === 'fixed'));
    return candidates[0] || null;
  }
  function getFixedHeaderOffset() {
    const hdr = document.querySelector('header, .header, .site-header');
    if (!hdr) return 12;
    const cs = getComputedStyle(hdr);
    const r = hdr.getBoundingClientRect();
    const fixedOrSticky = cs.position === 'fixed' || cs.position === 'sticky';
    const atTop = Math.round(r.top) <= 0;
    return (fixedOrSticky && atTop) ? Math.max(12, Math.min(64, r.height)) : 12;
  }
  function clampToViewport(x, y, pad = 12) {
    return {
      x: Math.min(Math.max(x, pad), innerWidth - pad),
      y: Math.min(Math.max(y, pad), innerHeight - pad)
    };
  }
  // haal contrasterende kleur (zwart/wit) bij gegeven bgColor
  function getContrastColor(cssColor) {
    const tmp = document.createElement('div');
    tmp.style.color = cssColor;
    document.body.appendChild(tmp);
    const rgb = getComputedStyle(tmp).color.match(/\d+/g);
    document.body.removeChild(tmp);
    if (!rgb) return '#fff';
    const [r, g, b] = rgb.map(Number);
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness > 140 ? '#000' : '#fff';
  }
  function createPlusChipSVG(size, bgColor) {
    const svgNS = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(svgNS, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', size);
    svg.setAttribute('height', size);
    svg.style.position = 'fixed';
    svg.style.pointerEvents = 'none';
    svg.style.zIndex = '2147483647';
    svg.style.transformOrigin = 'center';
    svg.style.willChange = 'transform, opacity';
    svg.style.filter = 'drop-shadow(0 2px 8px rgba(0,0,0,.45))';

    const circle = document.createElementNS(svgNS, 'circle');
    circle.setAttribute('cx', '12');
    circle.setAttribute('cy', '12');
    circle.setAttribute('r', '11');
    circle.setAttribute('fill', bgColor);

    const plusColor = getContrastColor(bgColor);
    const strokeW = 3.2;

    const line1 = document.createElementNS(svgNS, 'line');
    line1.setAttribute('x1', '12');
    line1.setAttribute('y1', '5');
    line1.setAttribute('x2', '12');
    line1.setAttribute('y2', '19');
    line1.setAttribute('stroke', plusColor);
    line1.setAttribute('stroke-width', strokeW);
    line1.setAttribute('stroke-linecap', 'round');

    const line2 = document.createElementNS(svgNS, 'line');
    line2.setAttribute('x1', '5');
    line2.setAttribute('y1', '12');
    line2.setAttribute('x2', '19');
    line2.setAttribute('y2', '12');
    line2.setAttribute('stroke', plusColor);
    line2.setAttribute('stroke-width', strokeW);
    line2.setAttribute('stroke-linecap', 'round');

    svg.appendChild(circle);
    svg.appendChild(line1);
    svg.appendChild(line2);
    return svg;
  }

  // ——— main ———
  function bindFlyToCart() {
    if (document.__rusmCartAnimBound) return;
    document.__rusmCartAnimBound = true;

    document.addEventListener('click', function (e) {
      // Product cards use the circular fly-to-cart image instead of this plus chip.
      if (e.target.closest('.product-card [data-product-atc-button], .product-card [data-qty-plus], .product-card [data-qty-minus], .product-card .product-card__atc')) {
        return;
      }

      const icon = e.target.closest('span.product-card__atc-icon, button.product-form__submit');
      if (!icon) return;

      const productCard = icon.closest('.product-card, [data-product-id], form[action*="/cart/add"]');
      if (!productCard) return;

      let startEl =
        icon.closest('.product-card__atc-icon') ||
        icon.closest('button, a, .btn, [type="submit"]') ||
        productCard.querySelector('.product-card__atc-icon') ||
        icon;

      const cartEl = getCartTarget();
      if (!startEl) return;

      // Zorg dat we nooit starten vanuit een 'onzichtbaar' element (0x0, hidden op desktop)
      let sRect = startEl.getBoundingClientRect();
      if (sRect.width === 0 || sRect.height === 0) {
        const fallback = icon.closest('button, a, .btn, [type="submit"]') || productCard || icon;
        if (fallback) {
          startEl = fallback;
          sRect = startEl.getBoundingClientRect();
        }
      }

      const startX = sRect.left + sRect.width / 2;
      const startY = sRect.top + sRect.height / 2;

      let endX, endY;

      if (DEBUG_FORCE_LEFT) {
        // hard debug-eindpunt links-midden
        endX = 28;
        endY = innerHeight / 2;
      } else if (cartEl) {
        const cRect = cartEl.getBoundingClientRect();
        const inView = rectInViewport(cRect, 0); // geen tolerantie: strikt in beeld
        if (inView) {
          // normaal: naar het midden van het zichtbare cart-icoon
          endX = cRect.left + cRect.width / 2;
          endY = cRect.top + cRect.height / 2;
        } else {
          // Fallback ALTIJD naar rechts-boven (met header offset)
          const padTop = getFixedHeaderOffset();
          const padSide = 16;
          endX = innerWidth - padSide;
          endY = padTop;
        }
      } else {
        // Geen cart gevonden → ook rechts-boven
        const padTop = getFixedHeaderOffset();
        const padSide = 16;
        endX = innerWidth - padSide;
        endY = padTop;
      }

      ({ x: endX, y: endY } = clampToViewport(endX, endY, 12));

      // Chipkleur = actuele tekstkleur van de knop/cta
      const colorSource = startEl.closest('button, a, .btn, .product-card') || startEl;
      const chipBg = getComputedStyle(colorSource).color || '#244123';

      const size = Math.max(22, Math.min(34, sRect.width + 6));
      const flyer = createPlusChipSVG(size, chipBg);
      flyer.style.left = (startX - size / 2) + 'px';
      flyer.style.top  = (startY - size / 2) + 'px';
      document.body.appendChild(flyer);

      const dx = endX - startX;
      const dy = endY - startY;

      flyer.animate(
        [
          { transform: 'translate(0,0) scale(0.9) rotate(0deg)', opacity: 1 },
          { transform: 'translate(0,0) scale(1.05) rotate(6deg)', opacity: 1, offset: 0.12 },
          { transform: `translate(${dx * 0.55}px, ${dy * 0.85}px) scale(0.88) rotate(14deg)`, opacity: 0.9 },
          { transform: `translate(${dx}px, ${dy}px) scale(0.6) rotate(22deg)`, opacity: 0.12 }
        ],
        { duration: DURATION_MS, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'forwards' }
      ).onfinish = function () {
        flyer.remove();
        poofAt(endX, endY, chipBg);
      };
    });
  }

  function poofAt(x, y, bgColor) {
    const d = document.createElement('div');
    d.style.position = 'fixed';
    d.style.left = (x - 7) + 'px';
    d.style.top  = (y - 7) + 'px';
    d.style.width = '14px';
    d.style.height = '14px';
    d.style.borderRadius = '50%';
    d.style.pointerEvents = 'none';
    d.style.zIndex = '2147483647';
    d.style.background = bgColor;
    d.style.boxShadow = '0 0 0 2px #fff inset, 0 2px 8px rgba(0,0,0,.35)';
    document.body.appendChild(d);
    d.animate(
      [{ transform: 'scale(0.6)', opacity: 0.9 }, { transform: 'scale(1.4)', opacity: 0 }],
      { duration: 320, easing: 'cubic-bezier(.2,.8,.2,1)', fill: 'forwards' }
    ).onfinish = () => d.remove();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindFlyToCart, { once: true });
  } else {
    bindFlyToCart();
  }
  document.addEventListener('shopify:section:load', bindFlyToCart);
})();